import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { useEffect, useRef } from 'react';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './FullWidthBannerListing.module.scss';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

export const FullWidthBannerListing = ({ data, index }: LayoutPropType) => {

  //const
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const router = useRouter();

  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.sectionName, {
        position: index,
      });
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);

  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) =>
        handleItemClickWithDelegation(
          e,
          CARDID,
          data?.entityType,
          data?.data,
          data?.sectionName
        )
      }
    >
      <Swiper
        swiperModules={['Pagination', 'AutoPlay']}
        speed={500}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={true}
        slidesPerView={1}
        slides={data?.data?.map((item, i) => (
          <div key={item?.productId} id={CARDID} data-index={i} onClick={() => router.push(item?.redirectionUrl)}>
            <ShimmerImage
              src={item?.coverImage}
              className={classNames(s.image, 'cmn_touchable_area')}
              loading="eager"
            />
          </div>
        ))}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
      />
    </div>
  );
};
